import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';

import AvailabilityForm from '../../Cleaner/detail/AvailabilityForm';

const useStyles = makeStyles({
  root: {
    marginTop: 16,
  },
});

// Disponibilités on the dedicated vivier Show (plan 014): availability lives on
// the PERSON (care.cleaner_profile.availability, keyed on silae_id), so the same
// editor used on the cleaner fiche is reused here verbatim — no duplication.
const AvailabilityCard = ({ silaeId, sourceCleanerId }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.root}>
      <Card>
        <CardHeader
          title="Disponibilités"
          subheader="Planning hebdomadaire (rattaché au matricule)"
        />
        <CardContent>
          {!silaeId && (
            <Typography variant="body2" color="textSecondary">
              Aucun matricule (silae_id) sur cette fiche — la disponibilité ne
              peut pas être rattachée à la personne.
            </Typography>
          )}
          {silaeId && (
            <AvailabilityForm
              silaeId={silaeId}
              sourceCleanerId={sourceCleanerId}
            />
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

AvailabilityCard.propTypes = {
  silaeId: PropTypes.string,
  sourceCleanerId: PropTypes.string,
};

AvailabilityCard.defaultProps = {
  silaeId: '',
  sourceCleanerId: '',
};

export default AvailabilityCard;
